import React, { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { ShowToast } from '../../functions/ShowToast';
import moment from 'moment';
import { Loader } from '../Loader';
import simpleClock from '../../assets/animations/simpleClock2.json';
import '../../pages/Absences/styles/Absences.css';

export const ShowFestivo = (props) => {
  const [data, setData] = useState(null);
  const [observations, setObservations] = useState('');
  const [loading, setLoading] = useState(false);
  const [dayRecords, setDayRecords] = useState(null);
  const [totalDay, setTotalDay] = useState('0:00');

  // Carga los registros del empleado para el día festivo y calcula el acumulado total
  useEffect(() => {
    console.log(props.data);
    setData(props.data);
    setObservations('');
    if (props.data) {
      setLoading(true);
      const holiday = props.data.holidayDate || props.data.date;
      const dateKey = moment(holiday, ['DD/MM/YYYY', 'DD-MM-YYYY']).format('DD-MM-YYYY');
      const monthKey = moment(holiday, ['DD/MM/YYYY', 'DD-MM-YYYY']).format('MMMM-YYYY');

      // Consulta el documento mensual del usuario en Firestore
      getDoc(doc(db, 'users', props.data.uid, 'registros', monthKey))
        .then((document) => {
          if (document.exists() && document.data()?.[dateKey]) {
            const records = document.data()[dateKey];
            setDayRecords(records);

            // Obtener el acumulado del último tramo del día
            const keys = Object.keys(records);
            let lastAcumulado = '0:00';
            for (let k = keys.length - 1; k >= 0; k--) {
              if (records[k]?.totalAcumulado) {
                lastAcumulado = records[k].totalAcumulado;
                break;
              } else if (records[k]?.total) {
                lastAcumulado = records[k].total;
                break;
              }
            }
            setTotalDay(lastAcumulado);
          } else {
            setDayRecords({});
            setTotalDay('0:00');
          }
        })
        .catch((err) => {
          console.error('Error al cargar registros del festivo:', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.data]);

  /**
   * Confirma la solicitud de festivo:
   * 1. Actualiza todos los tramos del día a status: 'Aceptado'.
   * 2. Marca la notificación como procesada y aceptada.
   * 3. Envía un correo con las horas computadas y posibles observaciones.
   */
  const confirmNotification = async (data) => {
    setLoading(true);
    try {
      const holiday = data.holidayDate || data.date;
      const dateKey = moment(holiday, ['DD/MM/YYYY', 'DD-MM-YYYY']).format('DD-MM-YYYY');
      const monthKey = moment(holiday, ['DD/MM/YYYY', 'DD-MM-YYYY']).format('MMMM-YYYY');
      const docRef = doc(db, 'users', data.uid, 'registros', monthKey);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists() && docSnap.data()?.[dateKey]) {
        const currentRecords = docSnap.data()[dateKey];
        const updatedRecords = {};

        Object.keys(currentRecords).forEach((key) => {
          updatedRecords[key] = {
            ...currentRecords[key],
            status: 'Aceptado',
          };
        });

        await updateDoc(docRef, {
          [dateKey]: updatedRecords,
        });
      }

      // Marcar notificación como procesada y aceptada
      await updateDoc(doc(db, 'notifications', data.id), {
        processed: true,
        status: 'Aceptado',
      });

      // Enviar correo si está configurado
      if (process.env.REACT_APP_SERVERMAIL_APIKEY) {
        try {
          await fetch('https://us-central1-controlhorario-4c249.cloudfunctions.net/serverMail/sendMail', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + process.env.REACT_APP_SERVERMAIL_APIKEY,
            },
            body: JSON.stringify({
              to: data.email,
              subject: 'Solicitud de festivo ACEPTADA',
              content: `
                <p>Se ha ACEPTADO tu solicitud de festivo para el día ${data.holidayDate || data.date}.</p>
                <p>Total de horas computadas: ${totalDay}</p>
                ${observations !== '' ? `<hr /><p>Observaciones:</p><p>${observations}</p>` : ''}
              `,
            }),
          });
        } catch (mailErr) {
          console.error('Error al enviar correo:', mailErr);
        }
      }

      setData(null);
      setObservations('');
      ShowToast('Notificación enviada');
    } catch (error) {
      console.error('Error al confirmar festivo:', error);
      alert('Error al confirmar la solicitud de festivo');
    } finally {
      setLoading(false);
    }
  };

  /**
   * Rechaza la solicitud de festivo:
   * 1. Marca la notificación como procesada con status: 'Rechazado'.
   * 2. Envía un correo al empleado notificando el rechazo y el motivo indicado.
   */
  const deleteNotification = async (data) => {
    setLoading(true);
    try {
      // Marcar notificación como procesada y rechazada
      await updateDoc(doc(db, 'notifications', data.id), {
        processed: true,
        status: 'Rechazado',
      });

      // Enviar correo si está configurado
      if (process.env.REACT_APP_SERVERMAIL_APIKEY) {
        try {
          await fetch('https://us-central1-controlhorario-4c249.cloudfunctions.net/serverMail/sendMail', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + process.env.REACT_APP_SERVERMAIL_APIKEY,
            },
            body: JSON.stringify({
              to: data.email,
              subject: 'Solicitud de festivo RECHAZADA',
              content: `
                <p>Se ha RECHAZADO tu solicitud de festivo para el día ${data.holidayDate || data.date}.</p>
                ${observations !== '' ? `<hr /><p>Motivo del rechazo:</p><p>${observations}</p>` : ''}
              `,
            }),
          });
        } catch (mailErr) {
          console.error('Error al enviar correo:', mailErr);
        }
      }

      setData(null);
      setObservations('');
      ShowToast('Notificación enviada');
    } catch (error) {
      console.error('Error al rechazar festivo:', error);
      alert('Error al rechazar la solicitud de festivo');
    } finally {
      setLoading(false);
    }
  };

  if (!data) return null;

  const rawHoliday = data.holidayDate || data.date;
  const holidayDate = rawHoliday ? rawHoliday.replace(/-/g, '/') : moment().format('DD/MM/YYYY');

  return (
    <div className='content'>
      <h6>
        Solicitud de Festivo: <strong>{data.name}</strong>
      </h6>
      <hr />
      <div className='absence-item mt-4 mb-3'>
        <div className='card'>
          <div className='card-header d-flex align-items-center justify-content-between pe-5'>
            <h5 className='card-title mt-1'>Festivo trabajado</h5>
            <span>
              Año: <strong className='ms-2'>{data.year || moment(holidayDate, 'DD/MM/YYYY').format('YYYY')}</strong>
            </span>
          </div>
          <div className='card-body'>
            <div className='row mt-4'>
              <div className='col-md-3'>
                <div className='icon-calendar'>
                  <div id='weekday'>{moment(holidayDate, 'DD/MM/YYYY').format('MMM')}</div>
                  <div id='day'>{holidayDate.split('/')[0]}</div>
                </div>
              </div>
              <div className='col-md-5'>
                <p className='card-text'>{holidayDate}</p>
                <p>
                  <strong className='me-2'>Observaciones:</strong>
                  {data.observation || 'Sin justificación'}
                </p>
              </div>
              <div className='col-md-2 mt-4 text-center'>
                <p className='card-text'>{totalDay}</p>
              </div>
              <div className='col-md-2 mt-4 text-end pe-4'>
                <div className={`badge rounded-pill ${data.status || 'Pendiente'}`}>
                  <i className={`fa-solid fa-clock-rotate-left ${data.status || 'Pendiente'}`}></i>
                  <span className='text-white'>{data.status || 'Pendiente'}</span>
                </div>
              </div>
            </div>

            {dayRecords && Object.keys(dayRecords).length > 0 && (
              <div className='mt-4 mb-3'>
                <hr />
                {Object.entries(dayRecords).map(([idx, tramo]) => (
                  <div className='stretchs' key={idx}>
                    <p>
                      <strong>{'Tramo ' + (parseInt(idx) + 1)}</strong>
                    </p>
                    <div className='row'>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <label>Entrada:</label>
                          <input type='text' className='form-control' value={tramo.entrada || ''} placeholder={tramo.entrada || '-'} disabled />
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <label>Salida:</label>
                          <input type='text' className='form-control' value={tramo.salida || (tramo.entrada ? 'En curso' : '')} placeholder={tramo.salida || '-'} disabled />
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <label>Total:</label>
                          <input type='text' className='form-control' value={tramo.total || ''} placeholder={tramo.total || '-'} disabled />
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <div className='form-group'>
                          <label>Total Acumulado:</label>
                          <input type='text' className='form-control' value={tramo.totalAcumulado || ''} placeholder={tramo.totalAcumulado || '-'} disabled />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='card-footer mt-2'>
            <div className='mb-3'>
              <label htmlFor='observations' className='form-label'>
                Observaciones
              </label>
              <textarea className='form-control' id='observations' rows='3' value={observations} onChange={(e) => setObservations(e.target.value)}></textarea>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-footer pe-0'>
        <p>¿Desea aceptar la solicitud?</p>
        <button className='btn btn-success' disabled={loading} onClick={() => confirmNotification(data)}>
          Confirmar
        </button>
        <button className='btn btn-danger' disabled={loading} onClick={() => deleteNotification(data)}>
          Rechazar
        </button>
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)',
            zIndex: 9999,
          }}
        >
          <style>{`.loader-container p { color: #fff !important; font-weight: 500; font-size: 1.1rem; }`}</style>
          <Loader type={simpleClock} loop={true} width='100px' />
        </div>
      )}
    </div>
  );
};
